import type { ScoredItem, Section, SectionItem } from "../types.js";

function toSectionItems(items: ScoredItem[]): SectionItem[] {
  return items.map((item) => ({ id: item.id, type: item.type }));
}

export function createHeroSection(item: ScoredItem): Section {
  return {
    type: "hero",
    items: toSectionItems([item]),
    layout: {
      position: { row: 0, col: 0, colSpan: 2, rowSpan: 2 },
      emphasis: "high",
    },
  };
}

export function createGridSection(items: ScoredItem[], startRow: number): Section {
  return {
    type: "grid",
    items: toSectionItems(items),
    layout: {
      position: { row: startRow, col: 0, colSpan: 2, rowSpan: 1 },
      emphasis: "medium",
    },
  };
}

export function createListSection(items: ScoredItem[], startRow: number): Section {
  return {
    type: "list",
    items: toSectionItems(items),
    layout: {
      position: { row: startRow, col: 0, colSpan: 1, rowSpan: 1 },
      emphasis: "low",
    },
  };
}

export function createComboHighlightSection(items: ScoredItem[], startRow: number): Section {
  return {
    type: "combo-highlight",
    items: toSectionItems(items),
    layout: {
      position: { row: startRow, col: 0, colSpan: 2, rowSpan: 2 },
      emphasis: "high",
    },
  };
}
